import React from 'react';
import ProductSeriesDetailOverviewSolution from '../productSeriesDetailOverviewSolution';

const ProductModelDetailSolution = (props): JSX.Element => {
  return (
    <>
      <ProductSeriesDetailOverviewSolution {...props} isModelSolutions={true} />
    </>
  );
};

export default ProductModelDetailSolution;
